import { FormGroup } from '@angular/forms';
import { STATES } from '@tangilla/tg-ng-models';

export class OfficeSearchWidgetJson {
  showSearchFields = true;

  getWidgetJson(form: FormGroup, model: any) {
    return {
      valueChangesFunctions: {} as any,
      wrapperClass: 'row',
      questions: [
        {
          'type': 'text',
          'name': model?.jsonObj?.namesReplacements?.officeSearch || 'Office-Search',
          'title': 'Office Search',
          'includeInOutput': false,
          'description': 'Type the first few words of your office name to search',
          'requiredErrorText': 'required',
          'isRequired': true,
          'descriptionLocation': 'underTitle',
          'placeHolder': 'Type your office name...',
          //faltan validators
          class: 'col-sm-12 col-md-4',
          formControl: form.get('office_search'),
          controlName: 'office_search',
          controlVisibleIf: this.shouldShowSearchFields()
        },
        {
          'type': 'text',
          'name': model?.jsonObj?.namesReplacements?.officeSearchCity || 'Office-Search-City',
          'title': 'City',
          'includeInOutput': false,
          'width': '350px',
          'description': 'Filter by City',
          'descriptionLocation': 'underTitle',
          //'visibleIf': '{Office-Search-Type} = Office',
          'startWithNewLine': false,
          'placeHolder': 'City (e.g. San Francisco)',
          class: 'col-sm-12 col-md-4',
          formControl: form.get('city'),
          controlName: 'city',
          controlVisibleIf: this.shouldShowSearchFields()
        },
        {
          'type': 'dropdown',
          'name': model?.jsonObj?.namesReplacements?.officeSearchState || 'Office-Search-State',
          'title': 'State',
          'description': 'Filter by State',
          'descriptionLocation': 'underTitle',
          'maxWidth': '200px',
          'width': '200px',
          'isRequired': true,
          'startWithNewLine': false,
          //'visibleIf': '{Office-Search-Type} = Office and {MembershipType} != MLSOnly',
          //'defaultValue': '{v-state}',
          'choices': STATES.map(state => {
            return {
              value: state,
              label: state
            };
          }),
          class: 'col-sm-12 col-md-4',
          formControl: form.get('state'),
          controlName: 'state',
          controlVisibleIf: this.shouldShowSearchFields()
        },
        {
          'type': 'radiogroup',
          'name': model?.jsonObj?.namesReplacements?.office || 'office',
          'visible': true,
          'isRequired': true,
          'choices': [],
          'descriptionLocation': 'underTitle',
          'description': 'Please take care to select the correct firm location.',
          'title': 'Select your Office *',
          formControl: form.get('office_selected'),
          controlName: 'office_selected'
        },
        {
          'type': 'text',
          'name': 'OfficeNRDS',
          'visible': false
        },
        {
          'type': 'text',
          'name': 'office_name',
          'visible': false
        }
      ]
    };
  }

  shouldShowSearchFields() {
    const that = this;

    return () => {
      return that.showSearchFields;
    };
  }
}

/*'visibleIf': '{office_request_error}isempty',*/
